"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
/**
 * Hook for showing a dragPreview
 * @param DragPreview The drag preview component to render
 */
function useDragPreview(DragPreview) {
    // drag previews won't have layered functionality, so we can create the ref for them
    // here
    var ref = React.useRef(null);
    // render the dragPreview into a detached element to prevent it from appearing too early
    var dragPreviewRoot = document.createElement('div');
    var portaledComponent = function (props) {
        var sendProps = __assign({}, props, { ref: ref });
        return react_dom_1.createPortal(React.createElement(DragPreview, sendProps), dragPreviewRoot);
    };
    return [portaledComponent, ref];
}
exports.useDragPreview = useDragPreview;
